export default __webpack_public_path__ + "static/graph_vertical-ae4b813b63a66c42c63d67aa5d720770.svg";